Shopify.Cart = {
  add: async (id, quantity, properties) => {
    let response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        quantity,
        properties,
      }),
    });
    let data = await response.json();
    // console.log(data);
  },
  update: async (products) => {
    // Expecting products to be an array of objects like [{key: "123:abc", quantity: 2}, {key: "456:def", quantity: 0}]

    // Fetch the current cart to get the ordered list of line items
    let cart = await Shopify.Cart.get();
    let line_items = cart.items;

    // Create a map from line item key to new quantity for quick lookup
    let updateMap = {};
    products.forEach((product) => {
      updateMap[product.key] = product.quantity;
    });

    // Build the updates array: for each line item, use the new quantity if specified, else its current quantity
    let updates = line_items.map((item) => {
      if (updateMap.hasOwnProperty(item.key)) {
        return updateMap[item.key];
      } else {
        return item.quantity;
      }
    });

    // Send the updates array to the Shopify API
    let response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    });

    let data = await response.json();
    // console.log(data);
    return data; // Return the updated cart data
  },
  clear: async () => {
    let response = await fetch("/cart/clear.js", {
      method: "POST",
    });
    let data = await response.json();
    // console.log(data);
  },
  get: async () => {
    let response = await fetch("/cart.js");
    let data = await response.json();
    return data;
  },
  addTest: async () => {
    let response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: 54328644403524,
        quantity: 1,
        properties: {
          _BB_index: 1,
        },
      }),
    });
    let data = await response.json();
    // console.log(data);
  },
};

document.addEventListener("DOMContentLoaded", async function () {
  const cart = await Shopify.Cart.get();
  console.log("cart:", cart);
  const contactForm = document.getElementById("ContactForm");
  const lines = cart.items;
  const items = [];
  lines.forEach((line) => {
    const item = {
      title: line.title,
      quantity: line.quantity,
      line_price: line.line_price,
      url: `https://kadai-fire.myshopify.com/admin/products/${line.product_id}`,
    };
    items.push(item);
  });

  // style tag injection
  const style = document.createElement("style");
  style.innerHTML = `
    .cart__blocks {
      display: flex;
      flex-direction: row;
      gap: 2em;
      align-items: center;
    }
    .cart__blocks #quote-form {
      flex: 1;
    }

    .cart__blocks .contact__button button {
      width: 100%;
    }
`;

  document.head.appendChild(style);

  // add hidden input to contact form with cart items
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "contact[Cart Lines]";
  let value = "";
  items.forEach((item) => {
    value += `Title: ${item.title}\nQuantity: ${item.quantity}\nLine Price: ${item.line_price}\n\nAdmin Product URL: ${item.url}\n\n`;
  });
  input.value = value;
  console.log("value:", value);

  contactForm.appendChild(input);
});
